import Button from 'common/components/button'
import { useAppDispatch } from 'common/hooks/redux'
import { Add } from 'common/icons'
import { showTemplates } from 'features/futurama/store/contentSlice'

type Props = {
  isDisabled?: boolean
}

const AddWorkflowCardButton = ({ isDisabled }: Props) => {
  const dispatch = useAppDispatch()

  return (
    <div className="self-center">
      <Button
        data-cy="add-more-content-button"
        data-testid="add-more-content-button"
        variant="link"
        disabled={isDisabled}
        prefixIcon={
          <Add isDefaultColor={false} className="text-base-700 w-4 h-4" />
        }
        onClick={() => dispatch(showTemplates())}
      >
        Content
      </Button>
    </div>
  )
}

export default AddWorkflowCardButton
